import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const hsCodesSchema: CollectionCreateSchema = {
  name: CollectionName.HsCodes,
  fields: [
    {
      name: "code", //code
      type: "string",
      facet: false,
    },
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
    },
    {
      name: "parents",
      type: "string[]",
      facet: true,
    },
  ],
  visibility: CollectionVisibility.EC,
}
